import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDanhSachKiemKho,
  updateDataSearch,
} from "../../actions/DanhSachKiemKho";
export const SearchBarMobile = () => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchDanhSachKiemKho); //dataSearchTaiSan dinh nghia o rootreducer

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onSearch = () => {
    dispatch(getListDanhSachKiemKho(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListDanhSachKiemKho(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataSearch.makiemkho}
                      onChange={updateTextValue("makiemkho")}
                      onKeyDown={handleKeyDown}
                      placeholder="Người, mã kiểm kho ..."
                    />
                    <div className="form-control-position" onClick={onSearch}>
                      <i className="mdi mdi-magnify"></i>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
